define(function (require) {
    "use strict";

    var LE = require("app");
    var Template = require("personalization-web-agent-templates/sla.tmpl");
    var Button = require("ui/button/Button");
    var BaseAnchorView = require("personalization-views/BaseAnchorView");
    var positionsUtility = require("personalization-utils/positionsUtility");
    var Settings = require("codeTables/settings.json");
    var KpContent = require("ui.components/kpContent/kpContent");

    var SLAView = {};
    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        SLAView = BaseAnchorView.extend({
            template: Template,
            withUIComponents: true,
            className: "sla-container anchor hide",
            ui: {
                slaEditButton: ".sla-edit-button",
                currentDefaultSla: ".default-data",
                currentUrgentSla: ".urgent-data",
                currentFirstTimeSla: ".first-time-data",
                currentDefaultSlaUnits: ".default-time",
                currentUrgentSlaUnits: ".urgent-time",
                currentFirstTimeSlaUnits: ".first-time-time",
                autoCloseTime: ".auto-close-data",
                autoCloseUnit: ".auto-close-unit",
                knowledgePack: ".kp",
                autoCloseContainer: ".auto-close-container"
            },
            uiComponents: {
                editButton: {
                    type: Button,
                    options: {
                        el: "view.ui.slaEditButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onEditButtonClick"
                    }
                },
                kpContent: {
                    type : KpContent,
                    options : {
                        container: "view.ui.knowledgePack",
                        contentPermutation: KpContent.CONTENT_PERMUTATION.INLINE,
                        KPLink: LE.translator.translate("LEFramework.global.captions.learnMore"),
                        kpID: "configuring-response-times"
                    }
                }
            },

            initialize: function (options) {
                LEPersonalization.logger.info("initializing", "SLAView:initialize. options = " + options);
                this.anchorSelector = options.anchorSelector;
                this.featureId = options.featureId;
                BaseAnchorView.prototype.initialize.call(this, options);
            },
            onRender: function (options) {
                LEPersonalization.logger.info("rendering", "SLAView:onRender. options = " + options);
                var offset = positionsUtility.getOffset(this.anchorSelector, positionsUtility.POSITION_X.LEFT, positionsUtility.POSITION_Y.TOP);
                if (offset) {
                    this.$el.css(offset);
                }
            },
            onClose: function () {
                LEPersonalization.logger.debug("closing view", "SLAView:onClose.");
            },
            setSlaValues: function (options) {
                LEPersonalization.logger.debug("sets retrieved sla values", "SLAView:setSlaValues. options = " + options);
                var settingsCollection = options.settingsCollection;
                var slaUnitsList = LE.siteSettings.SlaUnitsSettings.getSlaUnitsListTranslated();
                var slaUnitsObject = {};
                _.each(slaUnitsList, function (obj) {
                    slaUnitsObject[obj.key] = obj.value;
                });

                var autoCloseInSec = settingsCollection.get(Settings.SETTING_ID.AUTO_CLOSE_TIME_SEC).getValue();
                var autoCloseValues = LE.siteSettings.SlaUnitsSettings.convertSec2OtherUnit(autoCloseInSec);

                this.ui.currentDefaultSla.text(settingsCollection.get(Settings.SETTING_ID.DEFAULT_SLA_RESPONSE_TIME).getValue());
                this.ui.currentUrgentSla.text(settingsCollection.get(Settings.SETTING_ID.URGENT_SLA_RESPONSE_TIME).getValue());
                this.ui.currentFirstTimeSla.text(settingsCollection.get(Settings.SETTING_ID.FIRST_TIME_SLA_RESPONSE_TIME).getValue());
                this.ui.autoCloseTime.text(autoCloseValues.time);
                this.ui.currentDefaultSlaUnits.text(slaUnitsObject[settingsCollection.get(Settings.SETTING_ID.DEFAULT_SLA_UNITS).getValue()]);
                this.ui.currentUrgentSlaUnits.text(slaUnitsObject[settingsCollection.get(Settings.SETTING_ID.URGENT_SLA_UNITS).getValue()]);
                this.ui.currentFirstTimeSlaUnits.text(slaUnitsObject[settingsCollection.get(Settings.SETTING_ID.FIRST_TIME_SLA_UNITS).getValue()]);
                this.ui.autoCloseUnit.text(slaUnitsObject[autoCloseValues.unit]);
                this.$el.removeClass("hide");
            },
            _onEditButtonClick: function () {
                LEPersonalization.logger.debug("Edit button was clicked", "SLAView:_onEditButtonClick.");
                this.trigger("sla:navigateToFeatureEdit");
            }
        });
    });

    return SLAView;
});
